import * as React from 'react';

import UnifiedAppCheckContext from 'bundles/unified-common/contexts/UnifiedAppCheckContext';

const UnifiedAppCheckProvider = ({ children }: { children: React.ReactNode }) => {
  return <UnifiedAppCheckContext.Provider value={true}>{children}</UnifiedAppCheckContext.Provider>;
};

export default UnifiedAppCheckProvider;
